import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';

import { Period } from '../models/period.model';
import {SettingService} from "./setting.service";

@Injectable()
export class PeriodService {
  periodChanged = new Subject<Period[]>();

  constructor(private settings: SettingService,
              private http: HttpClient) {
  }

  addPeriod(period: Period) {
    const requestUrl = this.settings.getConfig('client.url') + '/customer/periods';

    return this.http.put<Period>(requestUrl, JSON.parse(JSON.stringify(period)), this.settings.httpOptionWithToken());
  }

  updatePeriod(id: number, newPeriod: Period) {
    const requestUrl = this.settings.getConfig('client.url') + '/customer/periods/' + id;

    return this.http.patch<Period>(requestUrl, JSON.parse(JSON.stringify(newPeriod)), this.settings.httpOptionWithToken());
  }

  getPeriods(): Observable<Period> {
    const requestUrl = this.settings.getConfig('client.url') + '/customer/periods';

    return this.http.get<Period>(requestUrl, this.settings.httpOptionWithToken());
  }

  getPeriod(id: number) {
    const requestUrl = this.settings.getConfig('client.url') + '/customer/periods/' + id;

    return this.http.get<Period>(requestUrl, this.settings.httpOptionWithToken());
  }

  getFilteredPeriod(param: Object): Observable<Period> {
    const requestUrl = this.settings.getConfig('client.url') + '/customer/periods/filtered';

    return this.http.post<Period>(requestUrl, param, this.settings.httpOptionWithToken());
  }

  deletePeriod(id: number) {
    const requestUrl = this.settings.getConfig('client.url') + '/customer/periods/' + id;

    return this.http.delete<Period>(requestUrl, this.settings.httpOptionWithToken());
  }

  getPeriodByAcademicYear(param: Object): Observable<Period> {
    const requestUrl = this.settings.getConfig('client.url') + '/customer/periods/filtered-by-academic-year';

    return this.http.post<Period>(requestUrl, param, this.settings.httpOptionWithToken());
  }
}
